import React, { type FC } from 'react'
import { useAtom } from 'jotai'
import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { saveFilterCallback } from '../callbacks/form'
import { useAtomCallback } from 'jotai/utils'
import { isFormValidAtom } from '../state/validation'

const SaveButton: FC = () => {
  const intl = useIntl()
  const [isFormValid] = useAtom(isFormValidAtom)
  const saveFilter = useAtomCallback(saveFilterCallback)
  return (
    <Button
      kind={BUTTON_VARIANT_PRIMARY}
      size={BUTTON_SIZE_LG}
      data-mu-test='filter__cta-save'
      onClick={saveFilter}
      disabled={!isFormValid}
    >
      {intl.formatMessage({ id: 'Load.Common.Save' })}
    </Button>
  )
}

export default SaveButton
